module.exports = __webpack_public_path__ + "media/assets/images/category/Dances@2x-76f3b0e1d2037e2ad4be755d27e1d06b.png";